<template>
  <div class="min-h-screen flex bg-white dark:bg-gray-950 font-outfit">
    <!-- Left Side: Visual & Testimonial (Hidden on Mobile) -->
    <div
      class="hidden lg:flex w-1/2 relative overflow-hidden bg-gray-900 text-white p-12 flex-col justify-between"
    >
      <!-- Background Effect -->
      <div class="absolute inset-0 z-0">
        <div
          class="absolute inset-0 bg-linear-to-br from-indigo-600/30 to-purple-800/30 mix-blend-overlay"
        ></div>
        <div
          class="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=2564&auto=format&fit=crop')] bg-cover bg-center opacity-40 grayscale mix-blend-multiply"
        ></div>
      </div>

      <!-- Logo -->
      <div class="relative z-10">
        <Logo size="lg" on-dark />
      </div>

      <!-- Testimonial -->
      <div class="relative z-10 max-w-md">
        <div class="space-y-6">
          <p class="text-2xl font-light leading-relaxed text-gray-200">
            "Learning French felt impossible until I found TCF Canada. The immersion method just
            clicks—it's not memorizing, it's living the language."
          </p>
          <div class="flex items-center gap-4">
            <div
              class="w-10 h-10 rounded-full bg-indigo-500/20 flex items-center justify-center text-sm font-medium border border-indigo-400/30"
            >
              SJ
            </div>
            <div>
              <h4 class="font-medium text-white">Sarah Jenkins</h4>
              <p class="text-sm text-gray-400">Software Engineer, Paris</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Side: Auth Form -->
    <div class="w-full lg:w-1/2 flex items-center justify-center p-6 sm:p-12 relative">
      <!-- Mobile Background Gradient -->
      <div
        class="absolute inset-0 bg-linear-to-b from-indigo-50/50 to-white dark:from-gray-900 dark:to-gray-950 lg:hidden -z-10"
      ></div>

      <div class="w-full max-w-md space-y-8 animate-fade-in-up">
        <slot />
      </div>
    </div>
  </div>
</template>

<style>
.font-outfit {
  font-family: 'Plus Jakarta Sans', 'Be Vietnam Pro', sans-serif;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in-up {
  animation: fadeInUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}
</style>
